// extracted by mini-css-extract-plugin
export default {"wrapper":"yTZBV","title":"SqQq7","rules":"wo2gb","rule":"Jv4fT","bonus":"aXJ8H","text":"dME6L","image":"hoW29","link":"Zuh1H","button":"T05x5"};